<template>
  <!-- 指定 class  -->
  <div :class="setup.class.mainClass">
    <template v-for="(item, index) in setup.iconList">
      <!-- 保证key的唯一性 -->
      <div class="dqProgress-content" :key="index + 'c'">
        <!-- Arrow -->
        <div class="item-icon-arrow" v-if="setup.mode === 'arrow'">
          <i class="iconfont" :class="item.icon" />
        </div>
        <!-- Step  -->
        <template v-else>
          <img
            class="item-icon-step"
            :src="require(`@/assets/images/icon-group-${item.index}.png`)"
          />
        </template>
        <!-- 指定 class -->
        <p
          :class="['item-text', setup.class.itemTextClass]"
          :style="{ color: index === 0 && setup.mode === 'icon-dot' ? '#2954D0' : '' }"
        >
          {{ item.name }}
        </p>
      </div>

      <!-- between的 图标 -->
      <div
        :class="['icon-between-box', setup.class.betweenBoxSize]"
        v-if="index !== setup.iconList.length - 1"
        :key="index + 'i'"
      >
        <img :class="setup.class.betweenIcon" :src="require(`@/assets/images/${setup.mode}.png`)" />
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    setup: Object
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.dqProgress-main {
  padding: 30px 40px 0px 40px;
  // margin:30px 40px 49px 40px;
  @include displayCenter($justify-content: space-between, $align-items: flex-start);
}
.dot {
  padding: 30px 32px 0px 32px !important;
  // margin:30px 32px !important;
}
.dqProgress-content {
  // 居中
  @include displayCenter();
  flex-direction: column;
  .item-icon-arrow {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: $main-color;
    box-shadow: 0px 0px 11px 1px rgba(199, 199, 199, 0.4);
    // 居中背景中的 icon
    @include displayCenter();
    i {
      color: #fff;
      font-size: 48px;
    }
  }
  // 1 2 3 4 5
  .item-icon-step {
    height: 48px;
  }
  // 文本通用样式
  .item-text {
    font-weight: 200;
    margin-top: 12px;
  }
  // 箭头时的本文
  .item-text-arrow {
    font-size: 24px;
    color: rgba(51, 51, 51, 1);
  }
  // step 时的文本
  .item-text-step {
    font-size: 16px;
    color: rgba(153, 153, 153, 1);
  }
}
.icon-between-box {
  @include displayCenter();
  //  arrow
  .between-icon-arrow {
    width: 25px;
    height: 19px;
  }
  //  dot
  .between-icon-dot {
    width: 154px;
    height: 11px;
  }
}
// arrow 时的 icon box 高度
.between-box-90 {
  height: 90px;
}
// setp 时的 icon box 高度
.between-box-71 {
  height: 46px;
}
</style>
